//chapter1
export default {
    id : 3,//chapter number
    title : '03. FMEA 개요 (3) - FMEA의 탄생과 기본개념',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            source : 'c03.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            body1 : [
                'FMEA의 탄생',
                'FMEA의 기본개념',
            ],
            body2 : [
                'FMEA의 탄생에 대해 설명할 수 있다.',
                'FMEA의 기본개념에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            source : '03.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    question : 'FMEA는 미국의 BIG3 자동차에서 최초로 사용했다.',//html available
                    answer : "2",
                    explain : '최초 사용은 NASA이다.'
                },
                {
                    type : 'ox',
                    question : 'FMEA는 잠재적 고장영향에 의한 위험을 파악하는 것이다.',//html available
                    answer : "1",
                    explain : '고객에 미치는 영향이 RISK이다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            /*download : 'sample.pptx',//data folder*/
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <h3>1. FMEA 탄생과 변천과정</h3>
                        <li>RISK 평가를 위한 수단으로 점차 강조 확대되고 있음</li>
                        <li>AIAG-VDA FMEA 적용을 요구함</li>
                        <p class="mg10"></p>
                        <h3>2. FTA와 FMEA의 개념</h3>
                        <li>상호보완적 분석체계임</li>
                        <li>FMEA는 Bottom up 방법으로 현재 관리방법의 위험을 평가함</li>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'c03.mp4',
        },
    ]
}